var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sales"},[_c('div',[_c('h3',[_vm._v("Month to Date Sales")]),(!_vm.salesValue)?_c('div',{staticClass:"transaction-amount-loader"}):_vm._e(),_c('h4',[_vm._v(_vm._s(_vm.salesValue))])]),_c('div')])}
var staticRenderFns = []

export { render, staticRenderFns }